import qs from "qs";
import axios from "utils/axios";
import { AxiosResponse } from "axios";

// Constants
import { API } from "constants/api";
import {
    TUsersResponse,
    TeamsResponse,
    TAddTeamResponse,
    TUsersFiltersPayload,
    userFunctions,
} from "./user_management.types";
import {
    TCreateInvitationsPayload,
    TPendingInvitesResponse,
    TReminderPayload,
    TInvitesReponse,
    TProfileSharingPayload,
} from "pages/HubManagement/components/InviteUsers/InviteUsersModal.types";

export const getUsersManagement = (filters: Partial<TUsersFiltersPayload>): Promise<AxiosResponse<TUsersResponse>> =>
    axios.get(`${API.USER_MANAGEMENT.GET_USERS}?${qs.stringify(filters, { arrayFormat: "repeat" })}`);

export const getTeams = (useSelectedOrg = false): Promise<AxiosResponse<TeamsResponse>> =>
    axios.get(`${API.USER_MANAGEMENT.TEAMS}?only_user_org_selected=${useSelectedOrg}`);

export const addNewTeam = (data: { user_ids: number[]; teams: string[] }): Promise<AxiosResponse<TAddTeamResponse>> =>
    axios.post(API.USER_MANAGEMENT.NEW_TEAM, data);

export const removeTeamFromUser = (user_id: number, data: { teams: string[] }) =>
    axios.delete(API.USER_MANAGEMENT.DELETE_TEAM_FROM_USER(user_id), { data });

export const addUserToArchived = (user_id: number) => axios.patch(API.USER_MANAGEMENT.ARCHIVE_USER(user_id));

export const removeUserFromArchived = (user_id: number) => axios.patch(API.USER_MANAGEMENT.UNARCHIVE_USER(user_id));

export const addUserToGroup = (user_id: number, data: { groups: number[] }) =>
    axios.post(API.USER_MANAGEMENT.ADD_TO_GROUP(user_id), data);

export const removeUserFromGroup = (user_id: number, data: { groups: number[] }) =>
    axios.delete(API.USER_MANAGEMENT.DELETE_FROM_GROUP(user_id), { data });

export const getPendingInvitations = (org_id: number): Promise<AxiosResponse<TPendingInvitesResponse>> =>
    axios.get(`${API.USER_MANAGEMENT.GET_INVITATIONS}?org_id=${org_id}`);

export const sendNewInvitation = (payload: TCreateInvitationsPayload): Promise<AxiosResponse<TInvitesReponse>> =>
    axios.post(API.USER_MANAGEMENT.SEND_INVITATIONS, payload);

export const sendReminderInvitation = (payload: TReminderPayload): Promise<AxiosResponse<TInvitesReponse>> =>
    axios.patch(API.USER_MANAGEMENT.SEND_INVITATIONS, payload);

export const updateUserRoles = (user_id: number, group_id: number, data: { roles: string[] }) =>
    axios.put(API.USER_MANAGEMENT.UPDATE_USER_ROLES(user_id, group_id), data);

export const updateUserFunction = (user_id: number, group_id: number, data: { function: userFunctions }) =>
    axios.post(API.USER_MANAGEMENT.UPDATE_USER_FUNCTION(user_id, group_id), data);

export const requestProfileSharing = (
    payload: TProfileSharingPayload
): Promise<AxiosResponse<TProfileSharingPayload>> => axios.patch(API.USER_MANAGEMENT.SEND_INVITE_BY_USERID, payload);
